module.exports = __webpack_public_path__ + "static/media/goalscreen.0eb6bd55.png";